__turbopack_context__.v({
  "readMore": "ForumExcerpt-module-scss-module__qVR3sW__readMore",
  "root": "ForumExcerpt-module-scss-module__qVR3sW__root",
});
